<template>
  <div>
    <shift-settings-card
      v-if="activeType === 'voucher'"
      :apply-to-all-shifts="config.settings.apply_to_all_shifts"
      :active-type="activeType"
      :shift-limits="config.settings.shift_limits"
      :quantity-value="config.settings.quantity_in_period"
      @update="$emit('update-shift', $event)"
      @update-quantity="updateQuantity"
      :readonly="readonly"
      class="mt-4"
    />

    <shift-settings-card
      v-if="activeType === 'order'"
      :apply-to-all-shifts="config.settings.apply_to_all_shifts"
      :active-type="activeType"
      :limit-by-quantity="config.settings.limit_by_quantity"
      :limit-by-value="config.settings.limit_by_value"
      :shift-limits="config.settings.shift_limits"
      :max-orders-value="config.settings.max_orders"
      :max-order-value="config.settings.max_order_value"
      @update="$emit('update-shift', $event)"
      @update-max-orders="updateMaxOrders"
      @update-max-order-value="updateMaxOrderValue"
      :readonly="readonly"
      class="mt-4"
    />

    <shift-settings-card
      v-if="activeType === 'credit'"
      :apply-to-all-shifts="config.settings.apply_to_all_shifts"
      :active-type="activeType"
      :shift-limits="config.settings.shift_limits"
      :max-amount-value="config.settings.max_amount"
      @update="$emit('update-shift', $event)"
      @update-max-amount="updateMaxAmount"
      :readonly="readonly"
      class="mt-4"
    />

    <shift-settings-card
      v-if="activeType === 'money'"
      :apply-to-all-shifts="config.settings.apply_to_all_shifts"
      :active-type="activeType"
      :shift-limits="config.settings.shift_limits"
      :limit-amount-value="config.settings.limit_amount"
      @update="$emit('update-shift', $event)"
      @update-limit-amount="updateLimitAmount"
      :readonly="readonly"
      class="mt-4"
    />
  </div>
</template>

<script>
import ShiftSettingsCard from "../cards/ShiftSettingsCard.vue";

export default {
  name: "ShiftLimitFields",
  components: {
    ShiftSettingsCard,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
    activeType: {
      type: String,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.ensureShiftLimits();
  },
  methods: {
    ensureShiftLimits() {
      if (!this.config?.settings) return;
      if (!this.config.settings.shift_limits) {
        this.$set(this.config.settings, "shift_limits", this.createDefaultShiftLimits());
        return;
      }
      const defaults = this.createDefaultShiftLimits();
      Object.keys(defaults).forEach((key) => {
        if (!Array.isArray(this.config.settings.shift_limits[key])) {
          this.$set(this.config.settings.shift_limits, key, defaults[key]);
        }
      });
    },
    createDefaultShiftLimits() {
      return {
        quantity_in_period: [null, null, null, null],
        max_orders: [null, null, null, null],
        max_order_value: [null, null, null, null],
        max_amount: [null, null, null, null],
        limit_amount: [null, null, null, null],
      };
    },
    updateQuantity(value) {
      this.config.settings.quantity_in_period = value;
    },
    updateMaxOrders(value) {
      this.config.settings.max_orders = value;
    },
    updateMaxOrderValue(value) {
      this.config.settings.max_order_value = value;
    },
    updateMaxAmount(value) {
      this.config.settings.max_amount = value;
    },
    updateLimitAmount(value) {
      this.config.settings.limit_amount = value;
    },
  },
};
</script>
